import { Delete, Edit, Tv, Visibility } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import { GridActionsCellItem, GridColDef, GridRenderCellParams, GridRowParams } from "@mui/x-data-grid";
import { Playlist } from "../../Model/PlaylistModel";

export function getColumns(
  handleEdit: (params: GridRowParams<Playlist>) => void,
  handleDelete: (params: GridRowParams<Playlist>) => void,
  handleViewPlaylist: (params: GridRowParams<Playlist>) => void,
  handleWall?: (params: GridRowParams<Playlist>) => void
) {

  const columnsDesktop: GridColDef[] = [
    {
      hideable: false,
      field: 'name',
      headerName: 'Nome da Playlist',
      flex: 1,
      editable: false,
    },
    {
      hideable: false,
      field: 'itemsCount',
      headerName: 'Itens',
      width: 80,
      disableColumnMenu: true,
      filterable: false,
      sortable: false,
      editable: false,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (_value: any, row: Playlist) => row.items ? row.items.length : 0,
    },
    {
      hideable: false,
      field: 'code',
      headerName: 'Código',
      width: 110,
      disableColumnMenu: true,
      filterable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      editable: false,
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
          <Typography variant="body2" color="secondary" fontWeight={700}
            sx={{ fontFamily: 'monospace', letterSpacing: 1 }}>
            {params.value}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'actions',
      type: 'actions',
      width: 50,
      filterable: false,
      sortable: false,
      getActions: (params) => [
        <GridActionsCellItem icon={<Edit />} label="Editar"
          onClick={() => handleEdit(params)} showInMenu />,
        <GridActionsCellItem icon={<Visibility />} label="Visualizar"
          onClick={() => handleViewPlaylist(params)} showInMenu />,
        ...(handleWall ? [<GridActionsCellItem icon={<Tv />} label="Painel TV"
          onClick={() => handleWall(params)} showInMenu />] : []),
        <GridActionsCellItem icon={<Delete />} label="Deletar"
          onClick={() => handleDelete(params)} showInMenu />,
      ],
    },
  ]

  const columnsMobile: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Playlist',
      flex: 1,
      filterable: false,
      sortable: true,
      editable: false,
      renderCell: (params: GridRenderCellParams<any, string>) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', py: 0.5 }}>
          <Typography variant="body2" fontWeight={500} noWrap>{params.value}</Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.items?.length ?? 0} {params.row.items?.length === 1 ? 'item' : 'itens'}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'actions',
      type: 'actions',
      disableColumnMenu: true,
      width: 50,
      getActions: (params) => [
        <GridActionsCellItem icon={<Edit />} label="Editar"
          onClick={() => handleEdit(params)} showInMenu />,
        <GridActionsCellItem icon={<Visibility />} label="Visualizar"
          onClick={() => handleViewPlaylist(params)} showInMenu />,
        ...(handleWall ? [<GridActionsCellItem icon={<Tv />} label="Painel TV"
          onClick={() => handleWall(params)} showInMenu />] : []),
        <GridActionsCellItem icon={<Delete color="error" />} label="Deletar"
          onClick={() => handleDelete(params)} showInMenu />,
      ],
    },
  ]

  return [columnsDesktop, columnsMobile]
}
